import { Outlet } from "react-router-dom";

const Authentication = () => {
    return (
        <div className="w-full">
            <Outlet />
        </div>
    )
}

export default Authentication